function welcomeButtonStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { sidebarState } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    if (sidebarState == 'landing') {
        return {
            padding: pxToRem(6),

            "& .icon": {

                [breakpoints.up('xxs')]: {
                    width: pxToRem(32),
                    height: pxToRem(32),
                    borderRadius: borderRadius.md,
                    "& > *": {
                        fontSize: "16px !important",
                    },
                    "& > .MuiAvatar-root": {
                        width: pxToRem(24),
                        height: pxToRem(24),
                    }
                },
                [breakpoints.up('lg')]: {
                    width: pxToRem(36),
                    height: pxToRem(36),
                    borderRadius: borderRadius.lg,
                    "& > *": {
                        fontSize: "20px !important",
                    },
                    "& > .MuiAvatar-root": {
                        width: pxToRem(29),
                        height: pxToRem(29),
                    }
                },
                [breakpoints.up('xxl')]: {
                    width: pxToRem(40),
                    height: pxToRem(40),
                    borderRadius: borderRadius.lg,
                    "& > *": {
                        fontSize: "24px !important",
                    },
                    "& > .MuiAvatar-root": {
                        width: pxToRem(34),
                        height: pxToRem(34),
                    }
                },

                display: "grid",
                justifyContent: "center",
                alignItems: "center",
                color: white.main,
                shadow: breakpoints.md,
                transition: 'color 300ms ease-in-out, width 300ms ease-in-out, height 300ms ease-in-out, border-radius 300ms ease-in-out',
            },

            "& .label": {
                paddingLeft: pxToRem(16),
                transition: 'padding 300ms ease-in-out',

                "& > *": {
                    [breakpoints.up('xxs')]: {
                        fontSize: size.sm,
                    },
                    [breakpoints.up('lg')]: {
                        fontSize: size.md,
                    },
                    [breakpoints.up('xxl')]: {
                        fontSize: size.lg,
                    },

                    alignItems: 'center',
                    textAlign: 'center',
                    transition: 'font-size 300ms ease-in-out'
                },
            },
        }
    }
    else if (sidebarState == 'sidenav') {
        return {
            padding: pxToRem(6),

            "& .icon": {
                display: "grid",
                justifyContent: "center",
                alignItems: "center",
                color: white.main,
                width: pxToRem(32),
                height: pxToRem(32),
                shadow: breakpoints.md,
                borderRadius: borderRadius.md,
                transition: 'color 300ms ease-in-out, width 300ms ease-in-out, height 300ms ease-in-out, border-radius 300ms ease-in-out',
            },

            "& .label": {
                paddingTop: pxToRem(4),
                paddingLeft: pxToRem(8),
                transition: 'padding 300ms ease-in-out',

                "& > *": {
                    [breakpoints.up('xxs')]: {
                        fontSize: size.sm,
                    },
                    [breakpoints.up('x5l')]: {
                        fontSize: size.md,
                    },
                    textAlign: 'center',
                    transition: 'font-size 300ms ease-in-out'
                },
            },
        }
    }
    else if (sidebarState == 'mobile') {

    }
}

export {
    welcomeButtonStyle,
}